// extracted by mini-css-extract-plugin
export default {"container":"nk-z","title":"ok-z","linkContainer":"pk-z","viewItemLink":"qk-z"};